import React, { useEffect, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import { alpha, useTheme } from '@mui/material/styles';
import settings from '../settings.js';

const COOKIE_NAME = 'miwa_analytic_db';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

const DatabaseSwitcher = () => {
  const theme = useTheme();
  const url = settings.getUrl();
  const [options, setOptions] = useState([]);
  const [active, setActive] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${url}/system/db`, { credentials: 'include' })
      .then((response) => response.json())
      .then((data) => {
        if (cancelled) return;
        setOptions(Array.isArray(data.options) ? data.options : []);
        setActive(data.db || null);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  // Nothing to flip until we know the active DB; hide silently on failure.
  if (failed || !options.length || !active) {
    return null;
  }

  const isUat = active.includes('uat');

  const handleChange = (event, next) => {
    if (!next || next === active) return;
    document.cookie = `${COOKIE_NAME}=${next}; Path=/; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax`;
    window.location.reload();
  };

  return (
    <Tooltip
      title={
        isUat
          ? 'Browsing the UAT database - reads and writes hit UAT'
          : 'Active database - click to switch'
      }
    >
      <ToggleButtonGroup
        exclusive
        size="small"
        value={active}
        onChange={handleChange}
        aria-label="active database"
      >
        {options.map((option) => {
          const selected = option.name === active;
          const uat = option.name.includes('uat');
          return (
            <ToggleButton
              key={option.name}
              value={option.name}
              sx={{
                px: 1.25,
                py: 0.4,
                fontSize: '0.75rem',
                textTransform: 'none',
                color: 'text.primary',
                borderColor: 'divider',
                ...(selected && uat
                  ? {
                      backgroundColor: alpha(theme.palette.warning.main, 0.25),
                      color: theme.palette.warning.dark,
                    }
                  : selected
                  ? { backgroundColor: alpha(theme.palette.primary.main, 0.12) }
                  : {}),
              }}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Tooltip>
  );
};

export default DatabaseSwitcher;
